export * from '@primeuix/themes/lara/tooltip';
export { default } from '@primeuix/themes/lara/tooltip';
